import React from "react";

const Table = ({ tableData }) => {

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
      <table className="min-w-[1035px] lg:min-w-full table-auto text-sm text-gray-700">
        <thead className="bg-[#FBFBFD] text-xs text-gray-500 uppercase">
          <tr>
            <th className="text-left uppercase text-sm p-3">ID</th>
            <th className="text-left uppercase text-sm p-3">Patient Name</th>
            <th className="text-left uppercase text-sm p-3">Doctor</th>
            <th className="text-left uppercase text-sm p-3">Mobile</th>
            <th className="text-left uppercase text-sm p-3">Serial</th>
            <th className="text-left uppercase text-sm p-3">Appointment Date</th>
            <th className="text-left uppercase text-sm p-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {tableData.slice(0, 6).map((row) => (
            <tr key={row.queueNumber} className="hover:bg-gray-50 border-b border-gray-200">
              <td className="p-3 text-sm">{row.queueNumber}</td>

              <td className="p-3 text-sm">
                { row.name ||"N/A"}
              </td>

              <td className="p-3 text-sm">
                <div className="flex items-center gap-2">
                  
                  <span>{ row.assignDr || "Unknown"}</span>
                </div>
              </td>

              <td className="p-3 text-sm">{row.phone  || "N/A"}</td>
              <td className="p-3 text-sm">{row.serial || "--"}</td>
              <td className="p-3 text-sm">{row.date || row.date}</td>

              <td className="p-3 text-sm">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${
                    row.status === "cancelled"
                      ? "bg-red-100 text-red-600"
                      : row.status === "approved"
                      ? "bg-green-100 text-green-700"
                      : "bg-orange-100 text-orange-600"
                  }`}
                >
                  {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : "N/A"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
